$(document).ready(function(){

  // wcag panel
    $('#wcagIcon').on('click', function() {
        $('#wcagPanel').toggleClass('opened')
    });

    $('.wcag__close').on('click', function() {
        $('#wcagPanel').removeClass('opened')
    });

  if(typeof sessionStorage["fontsize"] === "undefined")
    sessionStorage['fontsize'] = 0;

  var size = 0;
  $('.wcagFontsMinus').on("click", function () {
    if(size>-3 || size == 0){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) - 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) - 1);
      });
      size--;
    }
  });
  $('.wcagFontsPlus').on("click", function () {
    if(size<6){
      if ('sessionStorage' in window && typeof sessionStorage == 'object')
        sessionStorage["fontsize"] = parseInt(sessionStorage["fontsize"]) + 1;
      $('*').each(function(){
        $(this).css('font-size', parseInt($(this).css('font-size')) + 1);
      });
      size++;
    }
  });

  $('.wcagFontsReset').on("click", function () {
    sessionStorage['fontsize'] = 0;
    $('*').each(function(){
      $(this).removeAttr('style');
    });
  });

  $('.wcagFontsReads').on("click", function () {
      $('body').toggleClass('is_arial')
  });
  $('.wcagLinkUndeline').on("click", function () {
      $('body').toggleClass('is_underline')
  });
  $('.wcagLinkLighting').on("click", function () {
    $('body').toggleClass('is_lighting')
  });

  $('.wcagLinkReset ').on("click", function () {
    $('body').removeClass('is_lighting');
    $('body').removeClass('is_underline');
  });



  $('#wcagContrast-yellowBlack').on("click", function () {
    $('body').removeClass('blackYellow');
    $('body').removeClass('blackWhite');
    $('body').removeClass('whiteBlack');
    $('body').addClass('yellowBlack');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 1;
    }
  });


  $('#wcagContrast-blackYellow').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('whiteBlack');
    $('body').addClass('blackYellow');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 1;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });


  $('#wcagContrast-blackWhite').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('whiteBlack');
    $('body').removeClass('blackYellow');
    $('body').addClass('blackWhite');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 1;
      sessionStorage["whiteBlack"] = 0;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-whiteBlack').on("click", function () {
    $('body').removeClass('yellowBlack');
    $('body').removeClass('blackWhite');
    $('body').removeClass('blackYellow');
    $('body').addClass('whiteBlack');

    if ('sessionStorage' in window && typeof sessionStorage == 'object') {
      sessionStorage["blackYellow"] = 0;
      sessionStorage["blackWhite"] = 0;
      sessionStorage["whiteBlack"] = 1;
      sessionStorage["yellowBlack"] = 0;
    }
  });

  $('#wcagContrast-reset').on("click", function () {
    sessionStorage["blackYellow"] = 0;
    sessionStorage["blackWhite"] = 0;
    sessionStorage["whiteBlack"] = 0;
    sessionStorage["yellowBlack"] = 0;
    $('body').removeClass();
  });




    // Check if sessionStorage is supported
      if ('sessionStorage' in window && typeof sessionStorage == 'object') {
          if(parseInt(sessionStorage["fontsize"])!=0){
            var elements = $('*');
            var sizes = [];
            for(var i=0;i<elements.length;i++)
                sizes[i] = parseInt(elements.eq(i).css('font-size')) + parseInt(sessionStorage['fontsize']);
            for(var i=0;i<elements.length;i++)
              elements.eq(i).css('font-size', sizes[i]);
          }
          size = parseInt(sessionStorage['fontsize']);

          ["blackYellow","blackWhite","whiteBlack","yellowBlack"].forEach(function(element){
            if(parseInt(sessionStorage[element])==1){
              $('body').removeClass();
              $('#wcagContrast-'+element).trigger('click');
            }
          });
      }

      });
